import { createAsyncThunk } from "@reduxjs/toolkit";
import { setWidgetSetup } from "../../../../dashboardsSlice";
import { RootState } from "../../../../../store";
import { ChartType } from "../../../../../../services/cloudchipr.api";
import { getCostBreakdownV2WidgetSetupDataThunk } from "../getCostBreakdownV2WidgetSetupDataThunk";
import { costBreakdownV2WidgetSetupSelector } from "../../../../selectors/setups/cost-breakdown-v2/costBreakdownV2WidgetSetupSelector";

export const costBreakdownV2ViewTypeChangeThunk = createAsyncThunk(
  "dashboards/costBreakdownViewTypeChange",
  async (viewType: ChartType, { dispatch, getState }) => {
    const state = getState() as RootState;
    const existingSetup = costBreakdownV2WidgetSetupSelector(state);

    if (!existingSetup) {
      return;
    }
    dispatch(
      setWidgetSetup({
        ...existingSetup,
        viewType,
        frequency: viewType === "pie" ? "monthly" : existingSetup.frequency,
      }),
    );
    dispatch(getCostBreakdownV2WidgetSetupDataThunk());
  },
);
